import { render, staticRenderFns } from "./NaoAutorizado.vue?vue&type=template&id=9938b8ce&scoped=true"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js"
import style0 from "./NaoAutorizado.vue?vue&type=style&index=0&id=9938b8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9938b8ce",
  null
  
)

export default component.exports